var map = {
	"./3.png": "78Yz",
	"./BG2.jpg": "tlzZ",
	"./action-comedy.jpg": "v62l",
	"./action.jpg": "CYI3",
	"./adventure.jpg": "g8TF",
	"./animation.jpg": "CeVe",
	"./bg1.jpg": "F9VN",
	"./comedy-romance.jpg": "qSnp",
	"./comedy.jpg": "pj8S",
	"./crime.jpg": "2OpY",
	"./drama.jpg": "ZpJj",
	"./fantasy.jpg": "GqTM",
	"./horror.jpg": "yNi3",
	"./icon.png": "WTuT",
	"./logo.svg": "TYdL",
	"./logo2.png": "+1Cy",
	"./moviearcbg.jpg": "0VYX",
	"./mystery.jpg": "iBM4",
	"./romance.jpg": "YwJP",
	"./sci-fi.jpg": "4ONJ",
	"./superhero.jpg": "gTnC",
	"./thriller.jpg": "HKDW",
	"./transparentcubelogo.svg": "K7hL",
	"./transparenttextlogo.svg": "HAJA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";